import { useEffect } from "react";
import Nav from "./Nav";
import QuickActions from "./QuickActions";
import { PHONE, EMAIL } from "./shared";

const BUSINESS = "Parth Enterprises";
const ADDRESS = "Bandhwapara, Purani Basti, Raipur, Chhattisgarh, India";

const PAGES = {
  privacy: {
    title: "Privacy Policy",
    em: "Your data, respected.",
    seo: "Privacy Policy | Parth Enterprises",
    updated: "Last updated: September 2026",
    sections: [
      ["Information we collect", [
        `When you use our website, we may collect: your name, phone number, service requirement and message submitted through our enquiry forms; your email address, name and profile photo if you choose to sign in with Google; and basic visit information such as your IP address, browser type, pages visited and visit time.`,
      ]],
      ["How we use your information", [
        "We use this information only to respond to your enquiries, schedule and provide RO sales and service, maintain your Annual Maintenance Contract (AMC), improve our website, and keep basic visitor statistics for business purposes.",
        "We do not sell, rent or trade your personal information to anyone.",
      ]],
      ["Cookies", [
        "Our website uses cookies only to keep you signed in securely (session cookies) and to remember basic preferences. We do not use advertising or tracking cookies.",
      ]],
      ["Third-party services", [
        "We use Google Sign-In (for optional account login), WhatsApp (for chat and enquiry forwarding, when you choose to send), and website analytics. These services are governed by their own privacy policies.",
      ]],
      ["Data security & retention", [
        "Enquiry and account data is stored securely and retained only as long as needed to serve you or as required by law. You may ask us to correct or delete your information at any time.",
      ]],
      ["Contact us", [
        `For any privacy questions or requests, contact ${BUSINESS}, ${ADDRESS}. Phone: ${PHONE} · Email: ${EMAIL}.`,
      ]],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    em: "Clear terms, honest service.",
    seo: "Terms & Conditions | Parth Enterprises",
    updated: "Last updated: September 2026",
    sections: [
      ["Our services", [
        `${BUSINESS} (${ADDRESS}) provides RO water purifier sales, installation, repair, maintenance, filter replacement and Annual Maintenance Contracts (AMC) in Raipur and nearby areas.`,
        "Submitting an enquiry through this website is a service request, not a confirmed booking. All work is confirmed after direct discussion on phone or WhatsApp.",
      ]],
      ["Pricing & payment", [
        "Prices shared on the website, phone or WhatsApp are estimates. Final charges depend on the purifier model, condition, spare parts required and site conditions, and are always confirmed with you before work begins.",
        "Payment is due on completion of service unless agreed otherwise in writing.",
      ]],
      ["AMC plans", [
        "AMC coverage, visit schedules, included spare parts and exclusions are defined in your individual AMC agreement. Consumable parts such as filters and membranes may be chargeable depending on your plan.",
      ]],
      ["Service warranty", [
        "We stand by our workmanship. Service-specific warranties (where offered) are mentioned on your invoice or service receipt and apply to the work performed, subject to normal usage.",
      ]],
      ["Customer responsibilities", [
        "Customers should provide accurate information, safe access to the installation site, and use the purifier as per the manufacturer's instructions.",
      ]],
      ["Liability", [
        "We take utmost care during every service. Our liability is limited to the value of the service provided. We are not responsible for pre-existing damage, electrical or plumbing faults at the site, or issues arising from unauthorized repairs by third parties after our service.",
      ]],
      ["Governing law", [
        `These terms are governed by the laws of India, with jurisdiction of the courts of Raipur, Chhattisgarh. Contact: ${PHONE} · ${EMAIL}.`,
      ]],
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    em: "Honest expectations.",
    seo: "Disclaimer | Parth Enterprises",
    updated: "Last updated: September 2026",
    sections: [
      ["General information", [
        `The content on this website is provided by ${BUSINESS} for general information about our RO water purifier sales and services in Raipur. While we work to keep information accurate and up to date, we make no warranties about completeness or accuracy, and services, prices and availability may change without notice.`,
      ]],
      ["Brand names & trademarks", [
        "Kent, Aquaguard, Livpure, Pureit, Havells and all other brand names, logos and trademarks mentioned on this website belong to their respective owners. Mention of a brand indicates that we sell or service products of that brand; it does not imply that we are an authorized service center of that brand unless expressly stated in writing.",
      ]],
      ["No health claims", [
        "Water purification reduces many common contaminants, but information on this website is not medical advice. For specific water quality or health concerns, please consult a qualified professional and get your water tested.",
      ]],
      ["External links & services", [
        "Our website links to third-party services such as WhatsApp and Google. We are not responsible for the content, policies or availability of those services.",
      ]],
      ["Contact", [
        `Questions about this disclaimer? Contact ${BUSINESS}, ${ADDRESS}. Phone: ${PHONE} · Email: ${EMAIL}.`,
      ]],
    ],
  },
};

export default function LegalPage({ page }) {
  const data = PAGES[page];
  useEffect(() => { document.title = data.seo; window.scrollTo(0, 0); }, [data]);
  return (
    <main className="blog-page">
      <Nav/>
      <article className="blog-article container" data-testid={`legal-${page}`}>
        <p className="kicker"><span/> Legal</p>
        <h1>{data.title} — <em>{data.em}</em></h1>
        <p className="blog-lead">{data.updated}</p>
        {data.sections.map(([h2, paras]) => (
          <section key={h2}>
            <h2>{h2}</h2>
            {paras.map((p, i) => <p key={i}>{p}</p>)}
          </section>
        ))}
      </article>
      <QuickActions/>
    </main>
  );
}
